module.exports = __webpack_public_path__ + "static/img/03@2x.8baa6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/03@2x.png
// module id = qZi+
// module chunks = 1